var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-switch"},[_c('a-switch',{attrs:{"name":"id","checked":_vm.value,"disabled":_vm.disabled,"loading":_vm.isLoading},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }